import React from 'react'

import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@material-ui/core'
import {
  AlertCircle as AlertCircleIcon,
  CheckCircle as CheckCircleIcon,
  MinusCircle as MinusCircleIcon,
} from 'react-feather'

import { ResultItemList } from './components'

import useStyles from './styles'

const BulkActionResultDialog = ({
  open,
  setOpen,
  title,
  succeededCount = 0,
  skipped = [],
  failed = [],
  accentColor = null,
}) => {
  const classes = useStyles()

  const handleClose = () => setOpen(false)

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="bulk-action-result"
      fullWidth
      PaperProps={{
        style: {
          ...(accentColor && {
            borderRadius: 12,
            overflow: 'hidden',
            borderTop: `4px solid ${accentColor}`,
          }),
        },
      }}
    >
      <DialogTitle>
        <Typography variant="h5">{title}</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box className={classes.summary}>
          <Box className={classes.summaryItem}>
            <CheckCircleIcon size={18} className={classes.successIcon} />
            <Typography variant="body1">
              {succeededCount} concluído(s) com sucesso
            </Typography>
          </Box>
          {!isEmpty(skipped) && (
            <Box className={classes.summaryItem}>
              <MinusCircleIcon size={18} className={classes.skippedIcon} />
              <Typography variant="body1">
                {skipped.length} não aplicado(s)
              </Typography>
            </Box>
          )}
          {!isEmpty(failed) && (
            <Box className={classes.summaryItem}>
              <AlertCircleIcon size={18} className={classes.failedIcon} />
              <Typography variant="body1">{failed.length} com falha</Typography>
            </Box>
          )}
        </Box>

        {!isEmpty(failed) && (
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Falhas
            </Typography>
            <ResultItemList items={failed} />
          </Box>
        )}

        {!isEmpty(skipped) && (
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Não aplicados
            </Typography>
            <ResultItemList items={skipped} />
          </Box>
        )}
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

BulkActionResultDialog.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  succeededCount: PropTypes.number,
  skipped: PropTypes.array,
  failed: PropTypes.array,
  accentColor: PropTypes.string,
}

export default BulkActionResultDialog
